import { gsap } from '../lib/gsap/gsap.min'
import { ScrollTrigger } from '../lib/gsap/ScrollTrigger.min'

gsap.registerPlugin(ScrollTrigger)

export default class extends HTMLElement {
  connectedCallback () {
    this.letters = this.querySelectorAll('.logo-letter')
    this.icon = this.querySelector('.logo-icon')

    if (!this.letters.length || !this.icon) return

    if (!this.dataset.entranceAnimated) {
      this.initEntranceAnimation()
      this.dataset.entranceAnimated = 'true'
    }

    this.trigger = ScrollTrigger.create({
      trigger: document.body,
      start: 'top top',
      end: 'bottom bottom',
      scrub: 0.3,
      onUpdate: (self) => this.animate(Math.min(self.progress / 0.25, 1))
    })
  }

  initEntranceAnimation () {
    const header = this.closest('header')
    if (!header) return

    const headerCard = header.querySelector(':scope > div')
    const nav = header.querySelector('nav')
    const navLinks = nav?.querySelectorAll('a') || []
    const logoSvg = this.querySelector('svg')

    // Disable CSS transitions to prevent conflict with GSAP
    navLinks.forEach((link) => { link.style.transition = 'none' })

    // Hide immediately to prevent flash before animation
    gsap.set(headerCard, { opacity: 0, y: 40 })
    gsap.set(logoSvg, { opacity: 0, scale: 0.9 })
    gsap.set(navLinks, { opacity: 0, y: 12 })

    const tl = gsap.timeline({
      delay: 0.1,
      defaults: { ease: 'power3.out' }
    })

    tl.to(headerCard, { opacity: 1, y: 0, duration: 0.8 })
      .to(logoSvg, { opacity: 1, scale: 1, duration: 0.5 }, '-=0.5')
      .to(navLinks, { opacity: 1, y: 0, stagger: 0.05, duration: 0.4 }, '-=0.4')

    tl.eventCallback('onComplete', () => {
      navLinks.forEach((link) => { link.style.transition = '' })
    })
  }

  animate (progress) {
    this.letters.forEach((letter) => {
      const slide = parseFloat(letter.dataset.slide) || -100
      gsap.set(letter, {
        x: slide * progress,
        opacity: 1 - progress
      })
    })

    gsap.set(this.icon, {
      scale: 1 + progress * 0.5,
      transformOrigin: 'center center'
    })
  }

  disconnectedCallback () {
    this.trigger?.kill()
  }
}
